// extracted by mini-css-extract-plugin
export default {"container":"sba-z","tab":"tba-z","selected":"uba-z"};